export default [
  {
    id: 1,
    name: 'Monday',
    letter: 'M',
    date: ''
  },
  {
    id: 2,
    name: 'Tuesday',
    letter: 'T',
    date: ''
  },
  {
    id: 3,
    name: 'Wednesday',
    letter: 'W',
    date: ''
  },
  {
    id: 4,
    name: 'Thursday',
    letter: 'T',
    date: ''
  },
  {
    id: 5,
    name: 'Friday',
    letter: 'F',
    date: ''
  },
  {
    id: 6,
    name: 'Saturday',
    letter: 'S',
    date: ''
  },
  {
    id: 0,
    name: 'Sunday',
    letter: 'S',
    date: ''
  }
]
